import React from "react";
import logo from "../assets/walking-logos.png";

function WalkingLogos() {
  return <img src={logo} alt="walking" />;
}

export default WalkingLogos;
